// ZendeskWidgetController.jsx 6004224000
import React, { useEffect } from "react";
import { useGrowthBook } from "@growthbook/growthbook-react";
import DataLayerHelper from "../../../helpers/tagManager/DataLayerHelper";
 
const ZendeskWidgetController = () => {
  const growthbook = useGrowthBook();
  const isZendeskEnabled = growthbook.getFeatureValue("commercial-chatbot-data", false);

  useEffect(() => {
    if (isZendeskEnabled) {
      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=0a3b9e85-d324-4693-8ebf-905e6e254660"
      script.onload = () => {
        // @ts-ignore
        window.zE('messenger', 'close')
        // @ts-ignore
        window.zE("messenger:on", "open", () => {
          DataLayerHelper.pushEvent('select_content', {content_type: 'commercial-chatbot-data', content_id: 'commercial-chatbot-data-open'})
        });
      }
      document.head.appendChild(script);
      return () => {
        document.head.removeChild(script);
      }
    }
  }, [isZendeskEnabled]);

  return null;
};

export default ZendeskWidgetController;
